import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

export default class TouchBack extends Fragment {
    constructor() {
        super();

        this.code = "TB";
    }

    summarize(summaryContext) {
        const message = "touchback";
        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }
}
